<template>
  <div class="actions-container">
    <div class="actions">
      <button v-for="(action, index) in actions" :key="index">
        <img :src="require(`@/assets/actions/${action.img}`)" @click="handleFunctionCall(action.method)"
          :title="$t(action.hint)" />
      </button>
      <slot></slot>
    </div>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline"> {{ $t("dispatching.orderActions.chooseCaptain") }} </span>
        </v-card-title>
        <v-card-text>
          <v-autocomplete v-model="returnObject" clearable :items="captains" :loading="isLoading"
            :search-input.sync="search" outline dense :label="$t('dispatching.orderActions.captain')" item-text="text" item-value="text"
            :placeholder="$t('dispatching.orderActions.searchForCaptain')" no-filter return-object>
            <template slot="item" slot-scope="captains">
              <v-list-tile-content>
                <v-list-tile-title
                  v-html="captains.item.first_name + ' ' + captains.item.last_name"></v-list-tile-title>
                <v-list-tile-sub-title v-html="captains.item.username"></v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click="dialog = false">{{ $t("common.close") }}</v-btn>
          <v-btn color="primary" :loading="loading" flat @click="manualDispatch">{{ $t("dispatching.orderActions.dispatch") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="cancellationDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline"> {{ $t("dispatching.orderActions.cancellationReason") }} </span>
        </v-card-title>
        <v-card-text>
          <div v-for="option in userCancellationReasons" :key="option.id" class="radio-option">
            <input type="radio" :value="option.id" v-model="returnUserCancellationReason" :id="option.id"
              class="radio-input" />
            <label :for="option.id" class="radio-label">{{ option.text }}</label>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click="cancellationDialog = false">{{ $t("common.close") }}</v-btn>
          <v-btn color="primary" :loading="loading" flat @click="submitCancelOrder">{{ $t("common.submit") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import api from "@/constants/api.js";
let CancelToken = axios.CancelToken;
let cancel;

export default {
  name: "OrderActions",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      userCancellationReasons: [],
      edit: 0,
      loading: false,
      dialog: false,
      cancellationDialog: false,
      returnObject: "",
      returnUserCancellationReason: "",
      isLoading: false,
      search: null,
      captains: [],
    };
  },
  computed: {
    actions() {
      const actions = [];
      if (this.$route.name !== "Rides") {
        actions.push({
          img: "openMap.svg",
          hint: "dispatching.orderActions.hints.openDetails",
          method: "openDetails",
        });
      }
      if (this.$store.state.user.roles[0].name != "Goverment") {
        if (
          ["PENDING", "APPROVED", "ACCEPTED", "STARTED", "ARRIVED"].includes(
            this.data.status
          )
        ) {
          actions.push({
            img: "cancel.svg",
            hint: "dispatching.orderActions.hints.cancelOrder",
            method: "cancelOrder",
          });
        }

        // if (this.data.besoin) {
        //   actions.push({
        //     img: "renew.svg",
        //     hint: "Extend order TTL",
        //     method: "extendOrder",
        //   });
        // }
        {
          actions.push({
            img: "info.svg",
            hint: "dispatching.orderActions.hints.orderLogs",
            method: "orderLogs",
          });
        }

        if (
          ["APPROVED", "ACCEPTED", "PENDING", "STARTED", "ARRIVED"].includes(
            this.data.status
          ) &&
          this.data.now == 0
        ) {
          // actions.push({
          //   img: "changeTime.svg",
          //   hint: "Reschedule",
          //   method: "rescheduleOrder",
          // });
        }
        if (["APPROVED", "ACCEPTED", "ARRIVED", "STARTED"].includes(this.data.status)) {
          actions.push({
            img: "send-message-dm.svg",
            hint: "dispatching.orderActions.hints.sendReminder",
            method: "sendDispatchedReminder",
          });
        }
        if (this.data.status == "PENDING") {
          actions.push({
            img: "dispatch.svg",
            hint: "dispatching.orderActions.hints.manualDispatch",
            method: "dispatchPopup",
          });
          if (this.data.now)
            actions.push({
              img: "send-message-dm.svg",
              hint: "dispatching.orderActions.hints.sendReminder",
              method: "sendPendingReminder",
            });
        }
        {
          actions.push({
            img: "edit_black_24dp.svg",
            hint: "dispatching.orderActions.hints.editOrder",
            method: "editorder",
          });
        }
        if (this.data.now == 0 && ["APPROVED", "ACCEPTED"].includes(this.data.status)) {
          actions.push({
            img: "renew.svg",
            hint: "dispatching.orderActions.hints.redistributeOrder",
            method: "redistributeOrder",
          });
        }
        if (this.data.captain_conversation_id || (this.data.ride && this.data.ride.captain && this.data.ride.captain.conversation_id)) {
          actions.push({
            img: "email.svg",
            hint: "dispatching.orderActions.hints.captainChat",
            method: "goToCaptainChat",
          });
        }

        if (
          this.data.status != "PENDING" &&
          this.data.now == 0 &&
          this.data.origin == 'app'
        ) {
          actions.push({
            img: "chat.svg",
            hint: "dispatching.orderActions.hints.bookingChat",
            method: "goToBookingChat",
          });
        }

        if (
          this.data.status == "PAID" &&
          ((this.data.meta && this.data.meta.method == "INSIDE_APP") || (this.data.method == "INSIDE_APP"))
          
        ) {
          actions.push({
            img: "receipt.svg",
            hint: "dispatching.orderActions.hints.downloadReceipt",
            method: "downloadReceipt",
          });
        }
      }
      return actions;
    },
  },
  watch: {
    search(val) {
      this.isLoading = true;
      if (cancel) cancel();
      const params = new URLSearchParams(this.initialSearchParams);
      params.append("search", val);
      this.axios
        .get("captain/search", {
          params: params,
          cancelToken: new CancelToken(function executor(c) {
            cancel = c; // c is the cancel function
          }),
        })
        .then((res) => {
          this.captains = res.data.data.map((item) => ({
            text: `${item.full_name || ""}` + " " + `${item.username || ""}`,
            ...item,
          }));
        })
        .catch((err) => console.log(err))
        .finally(() => (this.isLoading = false));
    },
  },
  methods: {
    sendPendingReminder() {
      let orderDate = new Date(this.data.created_at);
      let currentDate = new Date();
      let dateMinus15Minutes = new Date(currentDate.getTime() - 15 * 60 * 1000);
      if (orderDate > dateMinus15Minutes) {
        window.getApp.$emit("SHOW_TOAST", this.$t("dispatching.orderActions.pendingReminderTooEarly"), "red");
        return;
      }


      this.$dialova({
        title: this.$t("dispatching.orderActions.sendReminder"),
        paragraph: this.$t("dispatching.orderActions.sendReminderToDrivers"),
        loader: true,
      })
        .then(({ close }) => {
          this.axios
            .post(`send_pending_reminder`, { booking_id: this.data.id })
            .then(() => {
              window.getApp.$emit(
                "SHOW_TOAST",
                this.$t("dispatching.orderActions.reminderSent"),
                "green"
              );
              // this.$store.commit("DELETE_BESOIN", this.data.id);
              close();
            })
            .catch((err) => {
              window.getApp.$emit("SHOW_TOAST", err.response.data.message || this.$t("dispatching.orderActions.errorOccurred"), "red");
              close();
            });
        })
        .catch(() => {
          console.log("cancelled");
        });
    },
    sendDispatchedReminder() {
      let orderDate = new Date(this.data.datetime);
      let currentDate = new Date();
      if (orderDate > currentDate) {
        window.getApp.$emit("SHOW_TOAST", this.$t("dispatching.orderActions.dispatchedReminderTooEarly"), "red");
        return;
      }


      this.$dialova({
        title: this.$t("dispatching.orderActions.sendReminder"),
        paragraph: this.$t("dispatching.orderActions.sendReminderToDriver"),
        loader: true,
      })
        .then(({ close }) => {
          this.axios
            .post(`send_dispatched_reminder`, { booking_id: this.data.id })
            .then(() => {
              window.getApp.$emit(
                "SHOW_TOAST",
                this.$t("dispatching.orderActions.reminderSent"),
                "green"
              );
              // this.$store.commit("DELETE_BESOIN", this.data.id);
              close();
            })
            .catch((err) => {
              window.getApp.$emit("SHOW_TOAST", err.response.data.message || this.$t("dispatching.orderActions.errorOccurred"), "red");
              close();
            });
        })
        .catch(() => {
          console.log("cancelled");
        });
    },
    editorder() {
      this.edit = 1;
      const routeData = this.$router.resolve({
        name: "PhoneBooking",
        query: {
          show_order_list: false,
          id: this.data.id,
          grouper: this.data.group_order,
          // date: this.data.datetime,
          edit: 1,
        },
      });
      window.open(routeData.href, "_blank");
    },
    dispatchPopup() {
      this.dialog = true;
    },
    goToCaptainChat() {
      const conversationId = this.data.captain_conversation_id ||
        (this.data.ride && this.data.ride.captain && this.data.ride.captain.conversation_id);
      this.$router.push('/messages?conversation=' + conversationId);
    },
    goToBookingChat() {
      const route = this.$router.resolve({
        name: "BookingChat",
        params: {
          id: this.data.id,
        },
      });
      window.open(route.href, '_blank');
    },
    downloadReceipt() {
      this.axios
        .get(`booking/${this.data.id}/receipt`, { responseType: "blob" })
        .then((res) => {
          const href = URL.createObjectURL(res.data);
          const link = document.createElement("a");
          link.href = href;
          link.setAttribute("download", `receipt-${this.data.id}.pdf`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
        })
        .catch(async (err) => {
          let message = "Failed to download receipt";
          if (err.response && err.response.data instanceof Blob) {
            try {
              const text = await err.response.data.text();
              message = JSON.parse(text).message || message;
            } catch (e) {
              // response wasn't JSON, keep default message
            }
          } else if (err.response && err.response.data && err.response.data.message) {
            message = err.response.data.message;
          }
          window.getApp.$emit("SHOW_TOAST", message, "red");
        });
    },
    manualDispatch() {
      this.loading = true;
      this.axios
        .put(`dispatch/${this.data.id}/${this.returnObject.id}`)
        .then(() => {
          window.getApp.$emit(
            "SHOW_TOAST",
            this.$t("dispatching.orderActions.dispatchedSuccessfully", { id: this.data.id }),
            "green"
          );

          this.dialog = false;
        })
        .catch((err) => {
          window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    orderLogs() {
      this.$router.push({
        name: "BookingLog",
        params: { id: this.data.id },
      });
    },
    handleFunctionCall(func) {
      this[func]();
    },
    formateDateTime(time) {
      return moment(time).format("HH[h]m - DD[/]MM[/]YYYY");
    },
    extendOrder() {
      this.$dialova({
        title: this.$t("dispatching.orderActions.keepInBesoinTitle", { id: this.data.id }),
        paragraph: this.$t("dispatching.orderActions.keepInBesoinParagraph", { id: this.data.id }),
        loader: true,
      })
        .then(({ close }) => {
          this.axios
            .post(`besoin/renew/${this.data.id}`)
            .then(() => {
              window.getApp.$emit(
                "SHOW_TOAST",
                this.$t("dispatching.orderActions.lifeExtended", { id: this.data.id }),
                "green"
              );
              // this.$store.commit("DELETE_BESOIN", this.data.id);
              close();
            })
            .catch((err) => {
              window.getApp.$emit("SHOW_TOAST", err, "red");
            });
        })
        .catch(() => {
          console.log("cancelled");
        });
    },
    redistributeOrder() {
      this.$dialova({
        title: this.$t("dispatching.orderActions.redistributeTitle", { id: this.data.id }),
        paragraph: this.$t("dispatching.orderActions.redistributeConfirm", { id: this.data.id }),
        loader: true,
      })
        .then(({ close }) => {
          this.axios
            .post(`redistribute/${this.data.id}`)
            .then(() => {
              window.getApp.$emit(
                "SHOW_TOAST",
                this.$t("dispatching.orderActions.redistributed", { id: this.data.id }),
                "green"
              );
            })
            .catch((err) => {
              window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
            })
            .finally(() => {
              close();
            });
        })
        .catch(() => {
          console.log("cancelled");
        });
    },
    cancelOrder() {
      this.$store
        .dispatch("getUserCancellationReasons")
        .then((data) => {
          this.userCancellationReasons = data;
          this.cancellationDialog = true;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    submitCancelOrder() {
      if (!this.returnUserCancellationReason) {
        window.getApp.$emit("SHOW_TOAST", this.$t("dispatching.orderActions.chooseReason"), "red");
        return;
      }
      this.loading = true;
      axios
        .delete(api.ACTIONS.BOOKINGS + `/${this.data.id}`, {
          params: {
            user_cancellation_reason_id: this.returnUserCancellationReason,
          },
        })
        .then(() => {
          window.getApp.$emit(
            "SHOW_TOAST",
            this.$t("dispatching.orderActions.orderCancelled", { id: this.data.id }),
            "green"
          );
          this.$emit("cancelled", this.data.id);
        })
        .catch((err) => {
          window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openDetails() {
      const route = this.$router.resolve({
        name: "Rides",
        params: {
          data: JSON.stringify(this.data),
          id: this.data.id,
        },
      });
      window.open(route.href, '_blank');
    },
    rescheduleOrder() {
      this.$dialova({
        title: this.$t("dispatching.orderActions.changeTimeTitle", { id: this.data.id }),
        paragraph: this.$t("dispatching.orderActions.changeTimeParagraph", {
          id: this.data.id,
          passenger: this.data.passenger.full_name,
          from: this.data.pick_up_location_details,
          to: this.data.pull_down_location_details
            ? this.data.pull_down_location_details
            : this.data.pull_down_location_name,
          datetime: this.formateDateTime(this.data.datetime),
        }),
        loader: true,
        input: this.$t("dispatching.orderActions.enterNewDatetime"),
        type: "datetime-local",
      }).then(({ close, value }) => {
        axios
          .put(`booking/${this.data.id}`, {
            datetime: `${moment(value).format("YYYY-MM-DD HH:mm")}`,
          })
          .then((res) => {
            window.getApp.$emit(
              "SHOW_TOAST",
              this.$t("dispatching.orderActions.timeChanged", {
                id: this.data.id,
                from: this.formateDateTime(this.data.datetime),
                to: this.formateDateTime(value),
              }),
              "green"
            );
            this.data.datetime = res.data.data.datetime;
          })
          .catch((err) => {
            console.log("ERROR");
            console.log(err.response);
            window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
          })
          .finally(() => {
            close();
          });
        console.log(value);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.radio-option {
  padding-left: 30px;
  display: flex;
  align-items: center;
  margin: 10px 0;
  font-family: 'Poppins';
}

.radio-input {
  margin-right: 10px;
  cursor: pointer;
  accent-color: #4caf50;
  /* Change color of the radio button in modern browsers */
}

.radio-label {
  font-size: 16px;
  cursor: pointer;
}

// w-full float-left
.actions-container {
  width: 100%;
  float: left;

  // w-full float-left mt-4 flex flex-row gap-2
  .actions {
    width: 100%;
    float: left;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0.5rem;

    button {
      max-height: 22px;
    }
  }
}
</style>
